import { Injectable } from '@angular/core';

import { EventModel, MyMarketModel, SportOptionGroup, SportOptionGroupOrder } from '@frontend/sports/betting-offer/feature/model';
import { LocalStoreService } from '@frontend/vanilla/core';
import { sortBy } from 'lodash-es';

import { EventMarketsTabBarItem } from '../../event-details-common/header/tab-group/event-header-tab-bar.models';

@Injectable({ providedIn: 'root' })
export class MarketGroupOrderService {
    constructor(protected localStorage: LocalStoreService) {}
    marketGroupOrderStorageKey = 'sia_marketgroup_order';

    getSortedMarketTabs(event: EventModel, tabs: EventMarketsTabBarItem[]): EventMarketsTabBarItem[] {
        const marketGroupOrder: MyMarketModel = this.localStorage.get(this.marketGroupOrderStorageKey) as MyMarketModel;

        return marketGroupOrder ? this.sortMarketsTabOrder(event, marketGroupOrder, tabs) : tabs;
    }

    private getTabsOrderBySportId(event: EventModel, marketGroupOrder: MyMarketModel): number[] {
        const sportTabsOrder = event.live ? marketGroupOrder.live : marketGroupOrder.prematch;
        if (!sportTabsOrder || Object.keys(sportTabsOrder).length === 0) {
            return [];
        }

        return this.isSportOptionGroupOrder(sportTabsOrder) ? sportTabsOrder[event.sport.id] : [];
    }

    private isSportOptionGroupOrder(sportTabsOrder: SportOptionGroup | SportOptionGroupOrder): sportTabsOrder is SportOptionGroupOrder {
        const firstVal = Object.values(sportTabsOrder)[0][0];

        return firstVal != null && typeof firstVal === 'number';
    }

    private sortMarketsTabOrder(event: EventModel, marketGroupOrder: MyMarketModel, tabs: EventMarketsTabBarItem[]): EventMarketsTabBarItem[] {
        const tabsOrderBySportId = this.getTabsOrderBySportId(event, marketGroupOrder);

        if (!tabsOrderBySportId || !tabsOrderBySportId.length) {
            return tabs;
        }

        tabsOrderBySportId.forEach((marketTab, index) => {
            const tabBarItem = tabs.find((tab) => tab.id === marketTab && tab.id !== 0);
            if (tabBarItem) {
                tabBarItem.marketTabOrder = index + 1;
            }
        });

        return sortBy(tabs, (tab) => tab.marketTabOrder);
    }
}
